import { createBreeNovaClient, describeDevice } from "@breenova/api-client";

/**
 * The one API client the app uses.
 *
 * The base URL is empty in development so requests go through Vite's `/api` proxy and
 * stay same-origin. In a Capacitor build there is no proxy — the app is served from the
 * device — so `VITE_API_BASE_URL` must point at the deployed API.
 */
const { client, store } = createBreeNovaClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? "",

  // Reached only after one silent refresh has already failed. Clearing storage is what
  // AuthProvider subscribes to, so the redirect happens through React rather than by
  // reaching for window.location here.
  onSessionLost: () => {
    store.clear();
  },
});

export const api = client;
export const tokenStore = store;
export { describeDevice };
